import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyCfQyRkHTG5-P9oOFYKFbi7iTu1JaOPkck",
  authDomain: "react-auth-92b69.firebaseapp.com",
  projectId: "react-auth-92b69",
  storageBucket: "react-auth-92b69.appspot.com",
  messagingSenderId: "45930961354",
  appId: "1:45930961354:web:d3e2f375fd7d6aa2ab1733",
};


const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export default app;
